import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { getEnvironmentMood } from "../../rendering/environment/environmentMath";
import { storyMotionState } from "../../rendering/story/storyMotionState";
import foliageUrl from "../../assets/environment/moonlit-foliage.png";
import "../../styles/environment-fallback.css";

gsap.registerPlugin(useGSAP);

/** A non-GPU landscape, not a replacement interaction layer. */
export function EnvironmentFallback({ storyActive, celebrating, reducedMotion }: {
  storyActive: boolean; celebrating: boolean; reducedMotion: boolean;
}) {
  const rootRef = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const root = rootRef.current;
    if (!root) return;
    const update = () => {
      if (document.hidden) return;
      const mood = getEnvironmentMood(storyMotionState.progress, storyActive, celebrating ? 1 : 0);
      root.style.setProperty("--garden", String(mood.garden));
      root.style.setProperty("--supper", String(mood.supper));
      root.style.setProperty("--moon", String(mood.moon));
      root.style.setProperty("--water", String(mood.water));
      root.style.setProperty("--flower-tint", ["236, 195, 205", "244, 231, 217", "230, 201, 145"][storyMotionState.palette] ?? "236, 195, 205");
    };
    update();
    if (!reducedMotion) gsap.ticker.add(update);
    window.addEventListener("birthday-scene-change", update);
    return () => {
      gsap.ticker.remove(update);
      window.removeEventListener("birthday-scene-change", update);
    };
  }, { scope: rootRef, dependencies: [storyActive, celebrating, reducedMotion], revertOnUpdate: true });

  return <div className="environment-fallback" ref={rootRef} aria-hidden="true">
    <div className="environment-fallback__clouds" />
    <div className="environment-fallback__moon" />
    <div className="environment-fallback__water" />
    <div className="environment-fallback__mist" />
    <div className="environment-fallback__lights" />
    <img className="environment-fallback__foliage" src={foliageUrl} alt="" />
  </div>;
}
